export default function scrollToContent(className: string) {
  try {
    const elem = document.getElementsByClassName(className)[0];
    const top = elem.getBoundingClientRect().top + window.pageYOffset - 50;
    window.scrollTo({ top, behavior: 'smooth' });
  } catch (_) {}
}
